import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DepartamentosCol } from '../interfaces/departamentos-col.interfaces';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CountriesService {

  constructor( private http: HttpClient ) { }

  getCountriesAndDepartments(): Observable<DepartamentosCol> {
    return this.http.get<DepartamentosCol>("./../../assets/json/colombia.json")
  }


}
